<template>
  <div class="btn-round__tooltip">
    <a class="btn--option" @click="downloadFile()">
      <i class="glicon-f-download"></i>
      <Tooltip :text="'tables.downloadBtn'"></Tooltip>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import UtilsService from '@/services/utils.service';
import CsvService from '@/services/csv.service';
import { CSV_FIELD_NAMES } from '../../assets/constants';
import Tooltip from './Tooltip';

export default {
  name: 'DownloadBtn',
  components: {
    Tooltip
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      admin: (state) => state.admins.admin
    })
  },
  methods: {
    downloadFile() {
      const rows = this.data.map((record) => {
        const newRecord = {};
        CSV_FIELD_NAMES.forEach((fieldName) => {
          newRecord[fieldName] = UtilsService.getDeepValue(record, fieldName);
        });
        return newRecord;
      });
      CsvService.dataToCsv(rows, 'csvFile', {
        showLabels: true,
        headers: Object.keys(rows[0])
      });
    }
  }
};
</script>
